import { render, staticRenderFns } from "./product-purchase-details-container.vue?vue&type=template&id=2aa16d0f&scoped=true&lang=pug"
import script from "./product-purchase-details-container.js?vue&type=script&lang=js&external"
export * from "./product-purchase-details-container.js?vue&type=script&lang=js&external"
import style0 from "./product-purchase-details-container.vue?vue&type=style&index=0&id=2aa16d0f&prod&lang=scss"
import style1 from "./product-purchase-details-container.vue?vue&type=style&index=1&id=2aa16d0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa16d0f",
  null
  
)

export default component.exports